import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../../../app/theme";

export const usePayDepositStyles = makeStyles((theme) => ({
  root: { fontFamily: fontFamily.Axiforma },
  stripeLogo: {
    "display": "flex",
    "alignItems": "center",
    "position": "absolute",
    "top": "28px",
    "right": "34px",
    "width": "140px",
    "padding": "1px",
    "justifyContent": "center",
    "& img": { objectFit: "cover", width: "100%" },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      top: "0",
      right: "0",
      marginLeft: "21px",
      marginBottom: "30px"
    }
  },
  payTerm: {
    margin: 0,
    fontSize: "14px",
    color: "#4b5462",
    marginBottom: "38px",
    [theme.breakpoints.down("sm")]: { fontSize: "12px" }
  },
  payConfirm: {
    "& .MuiCheckbox-root": {
      "padding": 0,
      "marginRight": "16px",
      "&.Mui-checked": {
        color: color.orange
      }
    },
    "& p": {
      "fontSize": "14px",
      "color": "#4b5462",
      "& a": {
        cursor: "pointer",
        color: color.orange,
        userSelect: "none",
        textDecoration: "none"
      },
      "& span": {
        cursor: "pointer",
        color: color.orange,
        userSelect: "none",
        textDecoration: "none"
      },
      [theme.breakpoints.down("sm")]: { fontSize: "12px" }
    }
  },
  payBtn: {
    "width": "267px",
    "height": "53px",
    "borderRadius": "27px",
    "fontSize": "18px",
    "fontWeight": 500,
    "background": color.orange,
    "color": "#fff",
    "marginTop": "38px",
    "marginBottom": "39px",
    "&:hover": { background: color.orange, color: "#fff" },
    "&:disabled": {
      background: color.orange,
      color: "#fff",
      opacity: "0.5"
    },
    "&.full": {
      width: "100%",
      marginBottom: "8px",
      [theme.breakpoints.down("sm")]: {
        marginTop: "8px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      width: "100%",
      height: "51px"
    }
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "50px",
    paddingBottom: "90px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "8px",
      paddingBottom: "34px"
    }
  },
  formContainer: {
    maxWidth: "482px",
    width: "100%",
    fontFamily: fontFamily.Axiforma,
    [theme.breakpoints.down("sm")]: {
      padding: "0 24px"
    }
  },
  formItem: {
    "width": "100%",
    "display": "flex",
    "marginBottom": "26px",
    "& .MuiFormLabel-root": {
      fontSize: "15px",
      fontWeight: 600,
      color: "#6d6d6d",
      fontFamily: fontFamily.Axiforma,
      marginBottom: "4px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& .MuiInputBase-input": {
      padding: "14px",
      fontSize: "14px",
      color: "#6d6d6d"
    },
    "& fieldset": {
      boxShadow: "0 1px 3px 0 rgba(220, 220, 220, 0.5)",
      border: "solid 1px #e0e0e0 !important",
      borderRadius: "9px"
    },
    "& .MuiInputBase-formControl:hover fieldset": {
      border: "solid 1px #e0e0e0"
    },
    "&.form-error": {
      "& fieldset": {
        boxShadow: "0 1px 3px 0 #fca5a5",
        border: "solid 1px #f87171 !important",
        borderRadius: "9px"
      },
      "& .MuiInputBase-formControl:hover fieldset": {
        border: "solid 1px #f87171"
      }
    }
  },
  formItemCard: {
    "boxShadow": "0 1px 3px 0 rgba(220, 220, 220, 0.5)",
    "border": "solid 1px #e0e0e0",
    "borderRadius": "9px",
    "& .card-number": {
      height: "47px",
      padding: "14px",
      borderBottom: "solid 1px #e0e0e0"
    },
    "& .card-expiry": {
      width: "50%",
      height: "47px",
      padding: "14px",
      borderRight: "solid 1px #e0e0e0"
    },
    "& .card-cvc": {
      width: "50%",
      height: "47px",
      padding: "14px"
    },
    "&.form-error": {
      "border": "solid 1px #f87171",
      "boxShadow": "0 1px 3px 0 #fca5a5",
      "& .card-number": {
        borderBottom: "solid 1px #f87171"
      },
      "& .card-expiry": {
        borderRight: "solid 1px #f87171"
      }
    }
  },
  note: {
    fontFamily: fontFamily.Axiforma,
    fontSize: "14px",
    color: "#4b5462",
    textAlign: "center",
    marginBottom: "53px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "29px"
    }
  },
  privacy: {
    "fontFamily": fontFamily.Axiforma,
    "fontSize": "14px",
    "color": "#4b5462",
    "textAlign": "center",
    "& a": {
      color: color.orange
    }
  },
  confirmText: {
    fontFamily: fontFamily.Axiforma,
    fontSize: "14px",
    color: "#4b5462",
    textAlign: "center"
  }
}));
